import React, { useEffect, useState } from 'react';
import './Portfolio.css'
import Work from './Work';

const Portfolio = () => {
    const [works, setWorks] = useState([])
    useEffect(() => {
        fetch('Portfolio.json')
            .then(res => res.json())
            .then(data => setWorks(data))
    }, [])
    return (
        <div className='portfolio'>
            <div className="container">
                <h1 className='sub-title'>My Work</h1>
                <div className="work-list">
                    {
                        works.slice(0, 3).map(work => <Work work={work}></Work>)
                    }
                </div>
                <a href="#" className='btn'>See More</a>
            </div>
        </div>
    );
};

export default Portfolio;